import { createSelector } from '@reduxjs/toolkit';

import { userApi } from './userApi';

export const selectUserAccountData = userApi.endpoints.getAccount.select();
export const selectUserAccount = createSelector(selectUserAccountData, (result) => result?.data);
export const selectUserAccountId = createSelector(selectUserAccountData, (result) => result?.data?.id);
export const selectUserAccountEmail = createSelector(selectUserAccountData, (result) => result?.data?.email);
export const selectUserAccountSocials = createSelector(selectUserAccountData, (result) => result?.data?.socials);
export const selectUserAccountJobTitle = createSelector(
  selectUserAccountData,
  (result) => result?.data?.jobTitle || undefined
);
